import '.a{display:flex;}.ssr-plugin'
import '.a6{align-items:stretch;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.cg{background:var(--shades-white);}.ssr-plugin'
import '.bc{flex-grow:1;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.b2{max-width:77.5rem;}.ssr-plugin'
import '.dq{justify-content:stretch;}.ssr-plugin'
import '.dr{position:sticky;}.ssr-plugin'
import '.d4{top:0;}.ssr-plugin'
import '.ds{z-index:10;}.ssr-plugin'
import '.dt{padding-block:1rem;}.ssr-plugin'
import '.du{height:3rem;}.ssr-plugin'
import '.a2{justify-content:space-between;}.ssr-plugin'
import '.dv{flex-wrap:wrap;}.ssr-plugin'
import '.dw{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.bj{margin-top:2rem;}.ssr-plugin'
import '.dx{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="a a6 b e cg"
      >
        <div className="bc a f b e"
        >
          <div className="b2 a e dq dr d4 ds cg"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="dt du a a2 f dv"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="dw a e a6 bj dx b2"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
